import React from "react"
import styled from "styled-components"

import { mediaDown } from "styles/media"
import { useIntl } from "react-intl"
import { blueGray, dark, purple } from "styles/colors"
import * as spacings from "styles/spacing"
import ImagesGrid from "components/ImagesGrid"
import FixedMenu from "components/FixedMenu"

const Container = styled.div`
  position: relative;
  padding: 140px 0;

  ${mediaDown.small`
    padding: 100px 0;
    padding-left: 0 !important;
  `}

  ${mediaDown.medium`
    padding-left: 90px;
  `}
`

const Inner = styled.div`
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
`

const TextContainer = styled.div`
  max-width: 720px;
  margin: 0 auto;

  ${mediaDown.medium`
    padding: 0 ${spacings.large};
    max-width: 100%;
  `}
`

const Title = styled.h2`
  font-size: 40px;
  color: ${dark};
  font-weight: 600;

  ${mediaDown.small`
    font-size: 32px;
  `}

  span {
    font-family: "Local Charter";
    font-style: italic;
    color: ${purple};
    font-weight: 800;
  }
`

const Subtitle = styled.h3`
  font-size: 24px;
  margin-bottom: ${spacings.medium};
  margin-top: ${spacings.xxxLarge};
  color: ${dark};
  font-weight: 600;

  ${mediaDown.small`
    font-size: 20px;
    margin-bottom: ${spacings.xLarge};
  `}
`

const Text = styled.p`
  font-size: 20px;
  color: ${blueGray};
  line-height: 36px;

  a {
    color: ${purple};
    font-weight: 600;
  }

  ${mediaDown.small`
    font-size: 16px;
    line-height: 26px;
  `}
`

const Content = () => {
  const intl = useIntl()

  return (
    <Container id="about">
      <Inner>
        <TextContainer>
          <Title>
            {intl.formatMessage({ id: "content.head1" })}
            <span>{` ${intl.formatMessage({ id: "content.head2" })}`}</span>
          </Title>

          <Subtitle>
            {intl.formatMessage({ id: "content.about.title" })}
          </Subtitle>

          <Text>{intl.formatMessage({ id: "content.about.content" })}</Text>
        </TextContainer>

        <ImagesGrid />

        <TextContainer>
          <Subtitle>
            <div
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ id: "content.media.title" })
              }}
            />
          </Subtitle>

          <Text>
            <div
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ id: "content.media.content" })
              }}
            />
          </Text>
        </TextContainer>

        <TextContainer>
          <Subtitle>
            <div
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ id: "content.thankyou.title" })
              }}
            />
          </Subtitle>

          <Text>
            <div
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ id: "content.thankyou.content" })
              }}
            />
          </Text>
        </TextContainer>
        <FixedMenu />
      </Inner>
    </Container>
  )
}

export default Content
